// extracted by mini-css-extract-plugin
export default {"bg":"modal_bg__JNrYv","blue":"modal_blue__48n3T","btn":"modal_btn__xW0eq"};